import React, { useState } from "react";
import Modal from "react-modal";
import { Create_Api } from "../ApiUrls";
import { toast } from "react-toastify";

Modal.setAppElement("#root");

const ContactModal = ({ isOpen, onClose }) => {

    const [IsUploading, setIsUploading] = useState(false);
    const [FirstName, setFirstName] = useState('');
    const [LastName, setLastName] = useState('');
    const [Email, setEmail] = useState('');
    const [Number, setNumber] = useState('');
    const [Message, setMessage] = useState('');

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isValidPhoneNumber = (number) => /^[6-9]\d{9}$/.test(number);
    const isValidName = (name) => /^[A-Za-z]{2,}$/.test(name);

    const SendContactUs = async () => {
        if (!FirstName.trim() || !isValidName(FirstName)) return toast.error('First Name must contain at least 2 letters and no numbers!');
        if (!LastName.trim() || !isValidName(LastName)) return toast.error('Last Name must contain at least 2 letters and no numbers!');
        if (!Email.trim() || !isValidEmail(Email)) return toast.error('Enter a valid email address!');
        if (!Number.trim() || !isValidPhoneNumber(Number)) return toast.error('Enter a valid 10-digit mobile number!');
        if (!Message.trim() || Message.length < 10) return toast.error('Message should be at least 10 characters long!');

        try {
            let data = {
                FirstName,
                LastName,
                Email,
                Number,
                Message
            }
            setIsUploading(true)
            const response = await Create_Api(`api/admin/CreateContactUs`, data)
            toast.success(response?.message);
            setFirstName('')
            setLastName('')
            setEmail('')
            setNumber('')
            setMessage('')
            onClose();
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            toast.error(error?.response?.data?.message);
            console.log(error)
        }
    }


    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} className="modal" overlayClassName="modaloverlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Contact Info</h2>
                    <button className="close-button" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="contact-form">
                    <div className="input-group">
                        <div className="input-field">
                            <label>First Name</label>
                            <input
                                type="text"
                                placeholder="Enter First Name"
                                value={FirstName}
                                onChange={(e) => { setFirstName(e.target.value) }}
                            />
                        </div>
                        <div className="input-field">
                            <label>Last Name</label>
                            <input
                                type="text"
                                placeholder="Enter Last Name"
                                value={LastName}
                                onChange={(e) => { setLastName(e.target.value) }}
                            />
                        </div>
                    </div>
                    <div className="input-field">
                        <label>Email</label>
                        <input
                            type="email"
                            placeholder="Enter Address"
                            value={Email}
                            onChange={(e) => { setEmail(e.target.value) }}
                        />
                    </div>
                    <div className="input-field">
                        <label>Number</label>
                        <input
                            type="number"
                            placeholder="Enter Number"
                            value={Number}
                            onChange={(e) => { setNumber(e.target.value) }}
                        />
                    </div>
                    <div className="input-field">
                        <label>Message</label>
                        <textarea
                            placeholder="Enter Address"
                            value={Message}
                            onChange={(e) => { setMessage(e.target.value) }}
                        ></textarea>
                    </div>
                    <button className="submit-button" onClick={() => { SendContactUs() }}>{IsUploading ? "Please Wait" : "Send"}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ContactModal;
